import { FlowList } from 'src/utils/redux/flow';
import reducerFactory from './reducer';

export const flows = new FlowList();

export const service = flows;
export const reducer = reducerFactory(flows);

export default {
  flows,
  service,
  reducer,
};
